class PredictiveSearch extends HTMLElement {
	static ANIMATION_TIME = 300;
	constructor() {
		super();
		this.initSearchTypes();
		this.isOpen = false;
		this.activeClass = 'predictive-search--open';
		this.resultsLimit = parseInt(this.dataset.resultsLimit);
		this.checkFocusBind = this.checkFocus.bind(this);
		this.elements = {
			input: document.querySelector('#Search'),
			results: document.querySelector('#SearchResults'),
			filters: this.querySelectorAll('.search__filter'),
			activeFilter: this.querySelector('.search__filter--active'),
			searchClose: this.querySelector('[data-search-close]'),
			searchOpen: document.querySelector('[data-search-open]'),
			searchContainer: this.querySelector('.search__wrapper'),
		};
		this.addListeners();
	}
	addListeners() {
		this.addEventListener('click', (event) => {
			if (event.target.classList.contains('predictive-search')) {
				this.close();
			}
		});
		this.elements.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event);
			}, PredictiveSearch.ANIMATION_TIME).bind(this)
		);
		document.querySelectorAll('[data-search-open]').forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.open();
				this.handleSearchFocus(PredictiveSearch.ANIMATION_TIME);
			});
		});
		document.querySelectorAll('[data-search-close]').forEach((button) => {
			button.addEventListener('click', (event) => {
				this.close();
			});
		});
		this.elements.filters.forEach((filter) => {
			filter.addEventListener('click', this.handleFilterClick.bind(this));
		});
	}
	checkFocus(event) {
		const { searchContainer } = this.elements;
		const searchContainerDescendents = searchContainer.querySelectorAll('a, button, input:not([type="hidden"]');

		const searchContainerFirstChild = searchContainerDescendents[0];
		const searchContainerLastChild = searchContainerDescendents[searchContainerDescendents.length - 1];

		if (!this.contains(document.activeElement) && event.relatedTarget == searchContainerFirstChild) {
			searchContainerFirstChild.focus();
		} else if (!this.contains(document.activeElement) && event.relatedTarget == searchContainerLastChild) {
			searchContainerLastChild.focus();
		}
	}
	close() {
		this.isOpen = false;
		this.classList.remove(this.activeClass);
		window.removeEventListener('focusin', this.checkFocusBind);
		this.elements.searchOpen.focus();
	}
	debounce(func, delay) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => func.apply(this, args), delay);
		};
	}
	getResults(terms) {
		const section_id = 'predictive-search-results';
		fetch(
			`/search/suggest?q=${terms}&resources[type]=${this.searchTypes}&resources[limit]=${this.resultsLimit}&section_id=${section_id}`
		)
			.then((response) => {
				if (response.ok) {
					return response.text();
				} else {
					this.hideResults();
					throw new Error(response.status);
				}
			})
			.then((text) => {
				const markup = new DOMParser().parseFromString(text, 'text/html');
				const results = markup.querySelector(`#shopify-section-${section_id}`).innerHTML;
				this.showResults(results);
			})
			.catch((error) => {
				this.hideResults();
				throw error;
			});
	}
	handleFilterClick(event) {
		event.preventDefault();
		const button = event.target;
		button.classList.add('search__filter--active');
		this.elements.activeFilter.classList.remove('search__filter--active');
		this.elements.activeFilter = button;
		this.searchTypes = button.dataset.searchType;
		this.onChange();
	}
	handleSearchFocus(delay = 0) {
		setTimeout(() => {
			if (this.isOpen) {
				this.elements.input.focus();
			} else {
				this.elements.input.blur();
			}
		}, delay);
	}
	hideResults() {
		this.elements.results.classList.add('search__results--hidden');
	}
	initSearchTypes() {
		const search_types = [];
		if (this.dataset.searchArticles === 'true') {
			search_types.push('article');
		}
		if (this.dataset.searchPages === 'true') {
			search_types.push('page');
		}
		if (this.dataset.searchProducts === 'true') {
			search_types.push('product');
		}
		this.searchTypes = search_types.join(',');
	}
	onChange() {
		const terms = this.elements.input.value.trim();
		if (terms.length > 0) {
			this.getResults(terms);
		} else {
			this.hideResults();
		}
	}
	open() {
		this.isOpen = true;
		this.classList.add(this.activeClass);
		window.addEventListener('focusin', this.checkFocusBind);
	}
	showResults(results) {
		this.elements.results.innerHTML = results;
		this.elements.results.classList.remove('search__results--hidden');
	}
}
customElements.define('predictive-search', PredictiveSearch);
